import styled from "styled-components";

// General Card for styling sections
export const StyledCard = styled.div`
    background-color: #f5f7fa;
    border: 1px solid #e0e4e8;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
`;

// Date Card for displaying the current date
export const DateCard = styled.div`
    background-color: #e8f4ff;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;
